/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InboundPictureDetailNodataVo
 */
export interface InboundPictureDetailNodataVo {
    /**
     * 无数据信息id
     * @type {number}
     * @memberof InboundPictureDetailNodataVo
     */
    noDataId?: number;
    /**
     * 区域
     * @type {string}
     * @memberof InboundPictureDetailNodataVo
     */
    zone?: string;
    /**
     * 库位
     * @type {string}
     * @memberof InboundPictureDetailNodataVo
     */
    locationNo?: string;
}

/**
 * Check if a given object implements the InboundPictureDetailNodataVo interface.
 */
export function instanceOfInboundPictureDetailNodataVo(value: object): value is InboundPictureDetailNodataVo {
    return true;
}

export function InboundPictureDetailNodataVoFromJSON(json: any): InboundPictureDetailNodataVo {
    return InboundPictureDetailNodataVoFromJSONTyped(json, false);
}

export function InboundPictureDetailNodataVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): InboundPictureDetailNodataVo {
    if (json == null) {
        return json;
    }
    return {
        
        'noDataId': json['noDataId'] == null ? undefined : json['noDataId'],
        'zone': json['zone'] == null ? undefined : json['zone'],
        'locationNo': json['locationNo'] == null ? undefined : json['locationNo'],
    };
}

export function InboundPictureDetailNodataVoToJSON(json: any): InboundPictureDetailNodataVo {
    return InboundPictureDetailNodataVoToJSONTyped(json, false);
}

export function InboundPictureDetailNodataVoToJSONTyped(value?: InboundPictureDetailNodataVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'noDataId': value['noDataId'],
        'zone': value['zone'],
        'locationNo': value['locationNo'],
    };
}

